export const LANGUAGES = [
  { code: "tr", name: "Türkçe", flag: "🇹🇷" },
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "ru", name: "Русский", flag: "🇷🇺" },
  { code: "ar", name: "العربية", flag: "🇸🇦" },
];

export const translations = {
  tr: {
    themeToggleLight: "Koyu moda geç",
    themeToggleDark: "Açık moda geç",
    goToPanel: "Panele Git",
    login: "Giriş Yap",
    register: "Kayıt Ol",
    heroTitle1: "Sıra yönetimini",
    heroTitle2: " kolaylaştırın",
    heroSubtitle:
      "Şubelerinizi, departmanlarınızı ve randevularınızı tek bir panelden yönetin. Müşteri deneyimini iyileştirin, operasyonları optimize edin.",
    getStartedFree: "Ücretsiz Başla",
    whylineo: "Neden lineo?",
    feature1Title: "Çoklu Şube",
    feature1Desc:
      "Tüm şubelerinizi merkezi bir panelden yönetin, performansı takip edin.",
    feature2Title: "Departman Yönetimi",
    feature2Desc:
      "Departmanlarınızı tanımlayın, personel atamalarını kolayca yapın.",
    feature3Title: "İstatistikler",
    feature3Desc:
      "Detaylı raporlar ve grafiklerle işletmenizi veri odaklı yönetin.",
    ctaTitle: "Hemen başlayın",
    ctaSubtitle: "Hesap oluşturun ve sıra yönetimini dönüştürün.",
    ctaButton: "Ücretsiz Kayıt Ol",
    footerRights: "Tüm hakları saklıdır.",
    privacyPolicy: "Gizlilik Sözleşmesi",
    termsOfService: "Kullanım Koşulları",
    cookiePolicy: "Çerez Politikası",
    accountDeletion: "Hesabımı Sil",
  },
  en: {
    themeToggleLight: "Switch to dark mode",
    themeToggleDark: "Switch to light mode",
    goToPanel: "Go to Panel",
    login: "Log in",
    register: "Sign up",
    heroTitle1: "Simplify",
    heroTitle2: " queue management",
    heroSubtitle:
      "Manage your branches, departments and appointments from a single panel. Improve customer experience, optimize operations.",
    getStartedFree: "Get Started Free",
    whylineo: "Why lineo?",
    feature1Title: "Multi-Branch",
    feature1Desc:
      "Manage all your branches from a central panel, track performance.",
    feature2Title: "Department Management",
    feature2Desc:
      "Define your departments, easily assign staff and manage workflows.",
    feature3Title: "Statistics",
    feature3Desc:
      "Manage your business data-driven with detailed reports and charts.",
    ctaTitle: "Get started now",
    ctaSubtitle: "Create an account and transform queue management.",
    ctaButton: "Sign Up Free",
    footerRights: "All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    cookiePolicy: "Cookie Policy",
    accountDeletion: "Delete My Account",
  },
  fr: {
    themeToggleLight: "Passer en mode sombre",
    themeToggleDark: "Passer en mode clair",
    goToPanel: "Aller au panneau",
    login: "Connexion",
    register: "S'inscrire",
    heroTitle1: "Simplifiez",
    heroTitle2: " la gestion des files",
    heroSubtitle:
      "Gérez vos succursales, départements et rendez-vous depuis un seul panneau. Améliorez l'expérience client, optimisez les opérations.",
    getStartedFree: "Commencer gratuitement",
    whylineo: "Pourquoi lineo ?",
    feature1Title: "Multi-succursales",
    feature1Desc:
      "Gérez toutes vos succursales depuis un panneau central, suivez les performances.",
    feature2Title: "Gestion des départements",
    feature2Desc:
      "Définissez vos départements, assignez facilement le personnel.",
    feature3Title: "Statistiques",
    feature3Desc:
      "Gérez votre entreprise de manière data-driven avec des rapports et graphiques détaillés.",
    ctaTitle: "Commencez maintenant",
    ctaSubtitle: "Créez un compte et transformez la gestion des files.",
    ctaButton: "S'inscrire gratuitement",
    footerRights: "Tous droits réservés.",
    privacyPolicy: "Politique de confidentialité",
    termsOfService: "Conditions d'utilisation",
    cookiePolicy: "Politique des cookies",
    accountDeletion: "Supprimer mon compte",
  },
  de: {
    themeToggleLight: "Zum dunklen Modus wechseln",
    themeToggleDark: "Zum hellen Modus wechseln",
    goToPanel: "Zum Panel",
    login: "Anmelden",
    register: "Registrieren",
    heroTitle1: "Vereinfachen Sie",
    heroTitle2: " die Warteschlangenverwaltung",
    heroSubtitle:
      "Verwalten Sie Ihre Filialen, Abteilungen und Termine in einem Panel. Verbessern Sie das Kundenerlebnis, optimieren Sie Abläufe.",
    getStartedFree: "Kostenlos starten",
    whylineo: "Warum lineo?",
    feature1Title: "Mehrere Filialen",
    feature1Desc:
      "Verwalten Sie alle Filialen zentral, verfolgen Sie die Leistung.",
    feature2Title: "Abteilungsverwaltung",
    feature2Desc:
      "Definieren Sie Abteilungen, weisen Sie Mitarbeiter einfach zu.",
    feature3Title: "Statistiken",
    feature3Desc:
      "Verwalten Sie Ihr Unternehmen datenbasiert mit detaillierten Berichten und Grafiken.",
    ctaTitle: "Jetzt starten",
    ctaSubtitle: "Konto erstellen und Warteschlangenverwaltung transformieren.",
    ctaButton: "Kostenlos registrieren",
    footerRights: "Alle Rechte vorbehalten.",
    privacyPolicy: "Datenschutzrichtlinie",
    termsOfService: "Nutzungsbedingungen",
    cookiePolicy: "Cookie-Richtlinie",
    accountDeletion: "Mein Konto löschen",
  },
  es: {
    themeToggleLight: "Cambiar a modo oscuro",
    themeToggleDark: "Cambiar a modo claro",
    goToPanel: "Ir al panel",
    login: "Iniciar sesión",
    register: "Registrarse",
    heroTitle1: "Simplifica",
    heroTitle2: " la gestión de colas",
    heroSubtitle:
      "Gestiona tus sucursales, departamentos y citas desde un solo panel. Mejora la experiencia del cliente, optimiza las operaciones.",
    getStartedFree: "Empezar gratis",
    whylineo: "¿Por qué lineo?",
    feature1Title: "Múltiples sucursales",
    feature1Desc:
      "Gestiona todas tus sucursales desde un panel central, sigue el rendimiento.",
    feature2Title: "Gestión de departamentos",
    feature2Desc: "Define tus departamentos, asigna personal fácilmente.",
    feature3Title: "Estadísticas",
    feature3Desc:
      "Gestiona tu negocio con datos mediante informes y gráficos detallados.",
    ctaTitle: "Empieza ahora",
    ctaSubtitle: "Crea una cuenta y transforma la gestión de colas.",
    ctaButton: "Registrarse gratis",
    footerRights: "Todos los derechos reservados.",
    privacyPolicy: "Política de privacidad",
    termsOfService: "Términos de servicio",
    cookiePolicy: "Política de cookies",
    accountDeletion: "Eliminar mi cuenta",
  },
  ru: {
    themeToggleLight: "Переключить на тёмный режим",
    themeToggleDark: "Переключить на светлый режим",
    goToPanel: "В панель",
    login: "Войти",
    register: "Регистрация",
    heroTitle1: "Упростите",
    heroTitle2: " управление очередями",
    heroSubtitle:
      "Управляйте филиалами, отделами и записями из одной панели. Улучшайте клиентский опыт, оптимизируйте операции.",
    getStartedFree: "Начать бесплатно",
    whylineo: "Почему lineo?",
    feature1Title: "Несколько филиалов",
    feature1Desc:
      "Управляйте всеми филиалами из центральной панели, отслеживайте показатели.",
    feature2Title: "Управление отделами",
    feature2Desc: "Определяйте отделы, легко назначайте персонал.",
    feature3Title: "Статистика",
    feature3Desc:
      "Управляйте бизнесом на основе данных с детальными отчётами и графиками.",
    ctaTitle: "Начните сейчас",
    ctaSubtitle: "Создайте аккаунт и преобразуйте управление очередями.",
    ctaButton: "Бесплатная регистрация",
    footerRights: "Все права защищены.",
    privacyPolicy: "Политика конфиденциальности",
    termsOfService: "Условия использования",
    cookiePolicy: "Политика cookies",
    accountDeletion: "Удалить мой аккаунт",
  },
  ar: {
    themeToggleLight: "التبديل إلى الوضع الداكن",
    themeToggleDark: "التبديل إلى الوضع الفاتح",
    goToPanel: "الذهاب إلى اللوحة",
    login: "تسجيل الدخول",
    register: "التسجيل",
    heroTitle1: "بسّط",
    heroTitle2: " إدارة الطوابير",
    heroSubtitle:
      "أدر فروعك وأقسامك ومواعيدك من لوحة واحدة. حسّن تجربة العملاء، وحسّن العمليات.",
    getStartedFree: "ابدأ مجاناً",
    whylineo: "لماذا lineo؟",
    feature1Title: "فروع متعددة",
    feature1Desc: "أدر جميع فروعك من لوحة مركزية، وتتبع الأداء.",
    feature2Title: "إدارة الأقسام",
    feature2Desc: "عرّف أقسامك، وعيّن الموظفين بسهولة.",
    feature3Title: "الإحصائيات",
    feature3Desc:
      "أدر عملك بالاعتماد على البيانات مع تقارير ورسوم بيانية مفصلة.",
    ctaTitle: "ابدأ الآن",
    ctaSubtitle: "أنشئ حساباً وحوّل إدارة الطوابير.",
    ctaButton: "التسجيل المجاني",
    footerRights: "جميع الحقوق محفوظة.",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الاستخدام",
    cookiePolicy: "سياسة ملفات تعريف الارتباط",
    accountDeletion: "حذف حسابي",
  },
};
